import Modal from "@Components/Modal";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { closeLeadFormModal } from "../LeadFormModal/data/leadFormReducer";
import styles from "./PartnerLeadFormModal.module.scss";
import { Suspense, lazy, useEffect, useState } from "react";
import FullPageLoader from "@Components/FullPageLoader";
import { AppState } from "@Store/index";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import useIsDesktop from "hooks/useIsDesktop";
import wrapperHOC from "@Utils/wrapperHOC";
import { utmSourceToDisplayIpdForm } from "./constants";

const PartnerLeadForm = lazy(() => import("./PartnerLeadForm"));

const LeadFormModalWithWrapper = ({ partnerData }: { partnerData: any }) => {
  const [utmSource, setUtmSource] = useState("");
  const dispatch = useDispatch();
  const handleHideModal = () => {
    dispatch(closeLeadFormModal());
  };

  const { openLeadFormModal } = useSelector(
    ({ leadFormModal }: AppState) => ({
      openLeadFormModal: leadFormModal.openLeadFormModal,
    }),
    shallowEqual,
  );

  const isDesktop = useIsDesktop();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const currentUtmSource = urlParams.get("utm_source") || "";
    setUtmSource(currentUtmSource);
  }, []);

  const getModalProps = () => {
    if (isDesktop) {
      return {
        size: "medium",
        align: "center",
        type: "LeadFormModal",
        className: formatClassNames(
          styles.leadFormModalContainer,
          styles.leadFormModalContainerDesktop,
          utmSourceToDisplayIpdForm.includes(utmSource) ? styles.containerWithIdpForm : "",
        ),
        closeBtnClassName: styles.closeBtnClassName,
      };
    }

    return {
      size: "fullScreen",
      type: "LeadFormModal",
      animation: "rightToLeftAnimation",
      className: formatClassNames(styles.leadFormModalContainer),
    };
  };

  return (
    <>
      {openLeadFormModal && (
        // @ts-ignore
        <Modal
          hideModal={handleHideModal}
          {...getModalProps()}
          zIndex={220}
          isHistoryPush={!isDesktop}
          hideCloseButton
          height={isDesktop ? "650px" : "100vh"}
        >
          <Suspense
            fallback={
              <FullPageLoader
                width={isDesktop ? "800px" : "100vw"}
                height={isDesktop ? "650px" : "100vh"}
              />
            }
          >
            <PartnerLeadForm partnerData={partnerData} />
          </Suspense>
        </Modal>
      )}
    </>
  );
};

export default wrapperHOC(LeadFormModalWithWrapper, {
  componentName: "LeadFormModalWithWrapper-PartnerLeadFormModal-Global",
  showForChina: true,
});
